import { EVENT_ATTENDANCE_OPENS_BEFORE_MS } from "../hooks/useEventAttendanceWindow";

// A chat reminder is shared with the whole event, while participant-action
// normally requires a per-user email marker. A participant who missed that
// marker must still be able to answer the event's active intention request.
export function canAnswerSharedEventIntent(event, participantAction, nowMs = Date.now()) {
  if (!event?.intent_confirmation_sent || !participantAction?.is_participant) return false;
  if (participantAction.intent_status !== "unknown" || event?.ticket_paid) return false;
  if (["finished", "deleted", "cancelled"].includes(String(event?.status || "").toLowerCase())) {
    return false;
  }

  const startsAtMs = new Date(event?.date_time).getTime();
  return Number.isFinite(startsAtMs) && nowMs < startsAtMs - EVENT_ATTENDANCE_OPENS_BEFORE_MS;
}
